module.exports = __webpack_public_path__ + "static/media/USDflag.02366485.png";